// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tailwin does not have class for grid-cols-5 */
.grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;IACI,gDAAgD;AACpD","sourcesContent":["/* Tailwin does not have class for grid-cols-5 */\n.grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
